<template>
  <router-link class="linkText" :class="LinkTextStyleClass" :to="href" :style="textColor">
    <slot />
  </router-link>
</template>

<script>
export default {
  name: 'linkText',
  props: {
    href: {
      required: true,
      type: String
    },
    color: {
      required: false,
      type: String,
      default: 'white'
    },
    shape: {
      required: false,
      type: String,
      validator: (value) => {
        return ['border', 'solid'].indexOf(value) !== -1
      },
      default: 'border'
    }
  },
  computed: {
    LinkTextStyleClass () {
      const shapeType = this.shape[0].toUpperCase() + this.shape.slice(1)
      return 'linkText--' + this.color + shapeType
    },
    textColor () {
      return {
        color: this.color
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../assets/stylesheets/variables';
@import '../../assets/stylesheets/mixins';

.linkText {
  color: $white;
  font-weight: bold;
  line-height: 1.4;
  letter-spacing: 0.1em;
  cursor: pointer;
}
</style>
